import React, { useEffect, useState } from 'react';
import MapViewMobile from './MapViewMobile';
import './app.css';

function App() {
  console.log('APP STARTED');
  const apiEndpoint = '.';
  const [position, setPosition] = useState(null);
  const [url, setUrl] = useState(null);

  const [isConnected, setIsConnected] = useState(false);
//  const [loginText, setLoginText] = useState("Login with Salesforce...");
  const [loginText, setLoginText] = useState(null);

// Example: set it after successful OAuth redirect or fetch
  useEffect(() => {
  
    fetch(`${apiEndpoint}/config/connected`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch connection');
        return res.json();
      })
      .then(({connStatus }) => {
        if (connStatus.connected == true) {
          setIsConnected(true);
          setUrl(connStatus.url);
        }
      })
      .catch(err => {
        console.error('Failed to get connection status:', err);
        alert("Failed to get connection status.");
      });
/*
      .then(({ connected }) => {
        if (connected == true) setIsConnected(true);;
      })
        */

      /*
    // Check login status via API or token presence
    const token = localStorage.getItem("salesforce_token");
    if (token) {
      setIsConnected(true);
    }
      */
  }, []);

  useEffect(() => {
    console.log('App.js - getting location');

    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const pos = { lat: coords.latitude, lng: coords.longitude };
        console.log('position: ', pos);
        setPosition(pos);
      },
      (err) => alert("Could not get location. Please allow location access.")
    );
  }, []);

  useEffect(() => {
 
  

  if (!isConnected) {
    console.log('APP - Checking connection.');
      setLoginText('Please login to continue');

  } else {
    setLoginText("Connected");

  }
})

//if (!position) return <div>Loading location...</div>;
console.log('App.js - position: ', position);
 if (!position) setPosition({ lat: 51.1144, lng: 4.4056 });
  
//<MapView center={position} />
//<MapView center={{ lat: 37.7749, lng: -122.4194 }} />

return (
    <div className="map-container">
        <div className="top-bar">
      <a
        href="./login"
        style={{
          display: 'inline-block',
          backgroundColor: '#0070d2', // Salesforce blue
          color: '#fff',
          padding: '12px 20px',
          fontSize: '16px',
          borderRadius: '8px',
          textDecoration: 'none',
          textAlign: 'center',
          fontWeight: 'bold',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          transition: 'background-color 0.3s ease',
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#005fb2')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#0070d2')}
      >
        {loginText}
      </a>
      URL: {url}
    </div>

      <div className='user-map'>  
      <MapViewMobile        
        center={position}
        isConnected={isConnected}
        url={url}
      />
    </div>
    </div>
  );
}
/*

      <MapView
        center={position}
        isConnected={isConnected}
        url={url}
      />

*/


export default App;

/*
  const handleLogin = () => {
    console.log('handling login...');
    window.location.href = "/auth/login";
  };

  if (!position) return <div>Loading location...</div>;
  return (
    <div>
      <button onClick={handleLogin}>Login with Salesforce</button>
      <MapView center={position} />
    </div>
  );
}

export default App;
*/
